export default [
  {
    code: 'code',
    name: 'code',
    type: 'id',
  },
  {
    code: 'type',
    name: 'type',
    type: 'select',
    dictionary: 'documenttype',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'number',
    name: 'number',
    type: 'input',
  },
  {
    code: 'from',
    name: 'from',
    type: 'select',
    dictionary: 'organization',
    itemValue: 'id',
    itemText: 'shortName',
  },
  {
    code: 'fromWarehouse',
    name: 'fromWarehouse',
    type: 'select',
    dictionary: 'organization',
    itemValue: 'id',
    itemText: 'shortName',
  },
  {
    code: 'to',
    name: 'to',
    type: 'select',
    dictionary: 'organization',
    itemValue: 'id',
    itemText: 'shortName',
  },
  {
    code: 'toWarehouse',
    name: 'toWarehouse',
    type: 'select',
    dictionary: 'organization',
    itemValue: 'id',
    itemText: 'shortName',
  },
  {
    code: 'status',
    name: 'status',
    type: 'select',
    dictionary: 'documentstatus',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'owner',
    name: 'owner',
    type: 'select',
    dictionary: 'user',
    itemValue: 'id',
    itemText: 'login',
  },
]
